import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#f5f0e6] shadow-md' : 'bg-transparent'}`} aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <span className="text-xl font-bold text-gray-900">
              S&amp;L Contractors
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-sky-600'
                    : 'text-gray-700 hover:text-sky-600'
                }`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="tel:251-348-8514"
              className="border-2 border-sky-500 text-sky-600 hover:bg-sky-500 hover:text-white px-6 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Book a Call
            </a>
            <a
              href="/contact"
              className="bg-navy-800 hover:bg-navy-900 text-white px-6 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#1e3a5f' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#152a45'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1e3a5f'}
            >
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle mobile menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#f5f0e6] border-t border-[#e5dfd3] py-4">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 px-4 text-sm font-medium cursor-pointer ${
                  isActive(link.path)
                    ? 'text-sky-600 bg-[#ebe5d9]'
                    : 'text-gray-700 hover:text-sky-600 hover:bg-[#ebe5d9]'
                }`}
              >
                {link.name}
              </a>
            ))}
            <div className="px-4 pt-4 space-y-3">
              <a
                href="tel:251-348-8514"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-center border-2 border-sky-500 text-sky-600 hover:bg-sky-500 hover:text-white px-6 py-3 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Book a Call
              </a>
              <a
                href="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-center text-white px-6 py-3 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#1e3a5f' }}
              >
                Get a Quote
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
